import React from 'react';
import "./../App.css";
import { Card, Button, InputGroup, Form, Col } from 'react-bootstrap';
import { wmsService } from "../services/wmsService"
import Scanner from "./Scanner";

class Receive extends React.Component {
    constructor(props) {
        super(props);
        //console.log(this.props)
        this.state = {    
            purchaseorder: null,        
            po: null,
            showScanner: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.goBack = this.goBack.bind(this);
        this.onNewScanResult = this.onNewScanResult.bind(this);  
        this.scan = this.scan.bind(this);
        this.lookup = this.lookup.bind(this);    
        this.closeScanner = this.closeScanner.bind(this);
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.po) {
            this.setState({purchaseorder: this.props.location.state.po});
        }
    }

    handleInputChange = (event) => {    
        const target = event.target;
        const name = target.id;   
        this.setState({
          [name]: target.value
        });   
      }

    handleSubmit(e) {        
        e.preventDefault();
        // First call getPurchaseOrder to see if the PO exists. If not then display error. Otherwise go to the next screen...
        wmsService.getPo(this.state.purchaseorder).then(pord => {
            if (pord && pord === 401) {
                this.props.history.push("/login");
            } else {
                if (pord.lineItem && pord.lineItem.length > 0) {
                    wmsService.adjustWms(this.state.purchaseorder, 1, pord.id, pord.lineItem).then(adj => { 
                        //console.log(adj)
                        if (adj && adj === 401) {
                            this.props.history.push("/login");
                          } else {
                            let user = JSON.parse(localStorage.getItem('user'));
                            let wmsempactivityreport = {};
                            wmsempactivityreport.invlocation = user.config.inventoryLocation;
                            wmsempactivityreport.wmsorder = this.state.purchaseorder;
                            wmsempactivityreport.employee = user.username
                            wmsempactivityreport.type = 4;
                            wmsempactivityreport.starttime = (new Date()).toISOString();
                            this.state.wmsempactivityreport = wmsempactivityreport;

                            this.setState({po: pord});
                            this.props.history.push("/receivelp", this.state);  
                            //var { from } = this.props.location.state || { from: { pathname: "/receivelp" } };  
                            //this.props.history.push(from, this.state);
                          }    
                    });
                    // this.setState({po: pord});
                    // var { from } = this.props.location.state || { from: { pathname: "/receivelp" } };  
                    // this.props.history.push(from, this.state);
                } else {
                    alert('PO or line items for the PO are not found or PO is in DRAFT status!');
                    return;
                }
            }
        });        
    }
    
    goBack =() => {
        var { from } = { from: { pathname: "/inbound" } };  
        this.props.history.push(from, this.state);
    }

    scan =() => {
        console.log('Scan is called');
      }

    lookup =() => {
        //console.log('Scan is called');
        var { from } = { from: { pathname: "/receiveposel" } };  
        this.props.history.push(from, this.state);
    }

    render() {
        return (
            
            <div>                
                <Card>
                    <Card.Header>Receiving Goods                        
                    </Card.Header>
                    <Card.Body>
                      <Form onSubmit={this.handleSubmit}>
                        <Form.Row>
                          <Form.Group as={Col} controlId="purchaseorder" onChange={this.handleInputChange}>
                            <Form.Label style={{fontSize: "14px"}}>PO #</Form.Label>
                            <InputGroup className="mb-3">
                                <Form.Control required={true} placeholder="Scan or enter purchase order number" defaultValue={this.state.purchaseorder} autoFocus />                                
                                <Button variant="outline-secondary" id="button-addon2" type="button" onClick={() => {this.scan()}}>
                                    Scan
                                </Button>
                            </InputGroup>
                           </Form.Group>
                        </Form.Row> 
                        <div style={{float: "left"}} >                                       
                        <Button variant="outline-primary mr-3" size="sm" type="submit">Next</Button>                              
                        <Button variant="outline-primary mr-3" size="sm" onClick={() => {this.scan()}}>Scan</Button>
                        <Button variant="outline-primary mr-3" size="sm" onClick={() => {this.lookup()}}>Lookup</Button>                              
                        <Button variant="outline-primary mr-3" size="sm" onClick={() => {this.goBack()}}>Cancel</Button>                              
                  </div>
                      </Form>
                      <Scanner showScanner={this.state.showScanner} closeScanner={this.closeScanner} onNewScanResult={this.onNewScanResult}></Scanner>
                    </Card.Body>
                </Card>
            </div>
            
        );
    }

    scan =() => {
        //console.log('Scan item is called');        
        this.setState({showScanner: true});
    }
    
    closeScanner() {
        this.setState({showScanner: false})
    }

    onNewScanResult(decodedText, decodedResult) {
        // Handle the result here.
        console.log('Scanned Result', decodedText, decodedResult);  
        this.setState({showScanner: false, purchaseorder: decodedText}); 
    } 
}
export default Receive;